import type { AnnotationClassPayload } from '@/store/types/AnnotationClassPayload'
import type { OntologyClass } from './ontologyTypes'

export const isAnnotationClass = (o: OntologyClass): o is AnnotationClassPayload => 'metadata' in o
